import { render, staticRenderFns } from "./LoadingWidget.vue?vue&type=template&id=4a4dea45&"
import script from "./LoadingWidget.vue?vue&type=script&lang=js&"
export * from "./LoadingWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports